<template>
  <div :class="['dot', showContent && 'has-content']" :style="dotStyle">{{showContent}}</div>
</template>
<script>
export default {
  name: 'Badge',
  props: {
    content: String | Number,
    dotStyle: Object
  },
  computed: {
    showContent () {
      return this.content && (parseInt(this.content) > 99 ? '99+' : this.content)
    }
  }
}
</script>
<style lang="postcss">
.dot {
  position: absolute;
  top: -3px;
  right: -3px;
  width: 6px;
  height: 6px;
  border-radius: 3px;
  background-color: #f55;

  &.has-content {
    box-sizing: border-box;
    top: -14px;
    right: 0;
    min-width: 28px;
    width: auto;
    padding: 0 2px;
    height: 28px;
    line-height: 28px;
    border-radius: 14px;
    font-size: 20px;
    color: #fff;
    text-align: center;
    transform: scale(.5) translate(50%, 0);
    transform-origin: right center;
  }
}
</style>
